import { useEffect, useState } from 'react';

import { useQuery } from 'hooks/useQuery';

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
};

export const getZendeskLocale = (lang, country) => {
    switch (lang) {
        case 'ru':
        case 'uk':
            return lang;
        case 'zh':
            return 'zh-cn';
        case 'en':
            return country === 'us' ? 'en-us' : 'en-gb';
        case 'es':
            return 'es-419';
        default:
            return 'en-gb';
    }
};

export const useGetQueryParams = () => {
    let query = useQuery();
    let theme = query.get('mode');
    let platform = query.get('platform');
    return { theme, platform };
};
